<template>
	<div class="ylist-page">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" :finished-text="list.length ? '没有更多了' : ''"
				:immediate-check="false" @load="onLoad">
				<div class="item card" v-for="(item, i) in list" :key="i" @click="goDetail(item)">
					<div class="item-top">
						<span class="time">反馈时间：{{ item.submitTime }}</span>
					</div>
					<div class="item-type">
						<span class="type">{{ item.complaintType }}</span>
						<van-icon name="arrow" class="arrow" />
					</div>
					<div class="content">{{ item.content }}</div>
				</div>
			</van-list>
			<van-empty v-if="finished && !list.length" description="暂无反馈记录" />
		</van-pull-refresh>
	</div>
</template>

<script>
	const MOCK = false; //假数据开关,样式参考用,联调时改回 false

	const MOCK_LIST = [{
		id: '1',
		complaintType: '功能异常',
		status: '1',
		statusLabel: '已处理',
		handleContent: '该问题已在最新版本修复，请更新后重试',
		content: '缴费页面打开后一直转圈，无法加载待缴账单，切换网络也没用，重启微信后仍然存在。',
		submitTime: '2026-08-18 09:32'
	}, {
		id: '2',
		complaintType: '产品建议',
		status: '0',
		statusLabel: '待处理',
		handleContent: '',
		content: '希望增加电子发票的开票记录导出功能，方便报销使用。',
		submitTime: '2026-08-17 15:47'
	}, {
		id: '3',
		complaintType: '安全分类',
		status: '0',
		statusLabel: '待处理',
		handleContent: '',
		content: '小区公告里有人发布可疑链接，建议加强内容审核。',
		submitTime: '2026-08-15 10:12'
	}, {
		id: '4',
		complaintType: '其它问题',
		status: '1',
		statusLabel: '已处理',
		handleContent: '已电话回访沟通，问题已解决',
		content: '想咨询一下物业费电子发票的开票时间。',
		submitTime: '2026-08-12 08:05'
	}, {
		id: '5',
		complaintType: '功能异常',
		status: '0',
		statusLabel: '待处理',
		handleContent: '',
		content: '门禁二维码每次打开都要重新登录一次，而且生成的二维码刷新很慢，经常在门禁前等好几秒才能刷上，高峰期特别影响通行效率，希望尽快优化一下。',
		submitTime: '2026-08-10 21:30'
	}, {
		id: '6',
		complaintType: '产品建议',
		status: '0',
		statusLabel: '待处理',
		handleContent: '',
		content: '建议在首页增加维修资金余额快捷入口。',
		submitTime: '2026-08-08 11:20'
	}];

	export default {
		data() {
			return {
				list: [], //反馈记录列表
				currpage: 0, //当前页码
				loading: false,
				finished: false,
				refreshing: false
			};
		},
		mounted() {
			this.onLoad();
		},
		methods: {
			onLoad() {
				if (this.refreshing) {
					//下拉刷新,重置分页
					this.currpage = 0;
					this.list = [];
					this.refreshing = false;
				}
				if (MOCK) {
					this.mockLoad();
					return;
				}
				this.$axios.get('/api/v1/tsjy/list', {
					params: {
						pageNum: this.currpage,
						pageSize: 15
					}
				}).then(res => {
					this.list.push(...(res.data || []));
					this.currpage++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				}).catch(() => {
					this.loading = false;
					this.finished = true;
				});
			},
			//假数据,模拟接口延迟
			mockLoad() {
				setTimeout(() => {
					this.list.push(...MOCK_LIST);
					this.currpage++;
					this.loading = false;
					this.finished = true;
				}, 500);
			},
			onRefresh() {
				this.finished = false;
				//重新加载数据
				this.loading = true;
				this.onLoad();
			},
			goDetail(item) {
				this.$router.push({
					path: '/yjfkdetail',
					query: { id: item.id }
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.ylist-page {
		min-height: 100vh;
		background: #f6f6f7;
		padding: 15px 15px 30px;
		box-sizing: border-box;
	}

	.card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
	}

	.item {
		margin-bottom: 10px;

		.item-top {
			margin-bottom: 8px;

			.time {
				font-size: 12px;
				color: #969799;
			}
		}

		.item-type {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 8px;

			.type {
				font-size: 15px;
				color: #323233;
				font-weight: bold;
			}

			.arrow {
				color: #c8c9cc;
			}
		}

		.content {
			font-size: 13px;
			color: #646566;
			line-height: 20px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			word-break: break-all;
		}
	}
</style>
